export const OVERFLOW_TOLERANCE_PX = 1;

export const elementHasOverflow = (
  element: Pick<HTMLElement, 'scrollWidth' | 'clientWidth' | 'scrollHeight' | 'clientHeight'>,
): boolean =>
  element.scrollWidth - element.clientWidth > OVERFLOW_TOLERANCE_PX ||
  element.scrollHeight - element.clientHeight > OVERFLOW_TOLERANCE_PX;
